import { ChakraProps } from '@chakra-ui/react';
import theme from '../../../theme';

export const modalCss: ChakraProps['css'] = {
  '.menu-item': {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    fontWeight: 800,
    padding: '1.5rem 0',
    height: 'auto',
    borderRadius: 0,
  },
  '> div, > button, > a': {
    borderBottom: `solid 1px ${theme.colors.gray[200]}`,
  },
};

export const contentProps = { bg: 'white' };
export const closeButtonProps = { bg: 'gray.50' };
